import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { buttonMarginSpace, buttonWidth } from '../../constants/form';
import { Routes } from '../../../../util/constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from '../../../../state';
import { closeModal } from '../../../../state/invoicePopupModalSlice';
import { useTranslation } from 'react-i18next';
import { openInvoiceModal } from '../../../../state/invoiceModalSlice';
import { popupFormWidth } from './constants';
import DraggablePaper from '../../DraggablePaper';

export default function CreateInvoicePopupModal() {
  const { t: tGlobal } = useTranslation([], {
    keyPrefix: 'team.Global.Buttons',
  });
  const { t: tCreateC } = useTranslation([], {
    keyPrefix: 'team.Modals.Invoices.createAndEdit.Create Invoice',
  });

  const { openInvoicePopupModal } = useSelector(
    ({ invoicePopupModalSlice }) => invoicePopupModalSlice,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleOpenCreateInvoicePopupModal = () => {
    handleClose();
    dispatch(openInvoiceModal({ resetState: true }));
  };

  return (
    <Dialog
      open={openInvoicePopupModal}
      onClose={(event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
      }}
      maxWidth="lg"
      scroll="paper"
      PaperProps={{ style: { width: popupFormWidth } }}
      PaperComponent={DraggablePaper}
    >
      <>
        <DialogTitle
          id="draggable-dialog-title"
          sx={{ m: 0, p: 1, cursor: 'move' }}
        >
          {tCreateC('Create Invoice')}
        </DialogTitle>
        <IconButton
          color="primary"
          sx={{ position: 'absolute', right: 4, top: 4 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ p: 1 }}>
          <Typography align="center">
            {tCreateC(
              'To avoid duplicate, it is suggested to search for existing invoices.',
            )}
          </Typography>
          <Typography align="center">
            {tCreateC('Search for existing invoices?')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box width="100%" sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: buttonWidth, marginRight: buttonMarginSpace }}
              onClick={handleClose}
            >
              {tGlobal('Cancel')}
            </Button>
            <Box>
              <Button
                variant="outlined"
                color="primary"
                sx={{ width: buttonWidth, marginRight: buttonMarginSpace }}
                onClick={() => {
                  navigate(Routes.HOME_INVOICES);
                  handleClose();
                }}
              >
                {tGlobal('Search')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: buttonWidth }}
                onClick={() => {
                  handleOpenCreateInvoicePopupModal();
                }}
              >
                {tGlobal('Create')}
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </>
    </Dialog>
  );
}
